<template>
    <div class="header-background-container" :class="{'no-photo': !hasPortfolio && !photoUrl}">
        <PortraitProfilePortfolio v-if="hasPortfolio" :portfolio="portfolio" :photo-url="photoUrl" @portfolio-clicked="$emit('portfolio-clicked')" />
        <PortraitProfilePhoto v-else-if="photoUrl" :photo-url="photoUrl" :alt="alt" face-crop />
    </div>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import PortraitProfilePhoto from './PortraitProfilePhoto.vue';
    import PortraitProfilePortfolio from './PortraitProfilePortfolio.vue';
    import type {PortfolioItem} from '../types';

    const props = defineProps<{
        photoUrl?: string;
        alt: string;
        portfolio: PortfolioItem[];
    }>();

    defineEmits<{
        'portfolio-clicked': [];
    }>();

    const hasPortfolio = computed(() => props.portfolio.length > 0);
</script>

<style scoped lang="scss">
    .header-background-container {
        position: absolute;
        z-index: -1;
        top: -1px;
        left: -1px;
        display: flex;
        align-items: center;
        overflow: hidden;
        // we add 2px to ensure there is no space between the contained image and the profile card border
        width: calc(100% + 2px);
        height: 100%;

        &.no-photo {
            background: var(--joy-color-neutral-30);
        }
    }
</style>
